import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common.service'
import { APIService } from 'src/app/api.service';
import { DataService } from '../../services/data.service';
import { StageTasksListComponent } from '../stage-tasks-list/stage-tasks-list.component';
import { EnterStageComponent } from '../enter-stage/enter-stage.component';

@Component({
  selector: 'app-process-stages',
  templateUrl: './process-stages.component.html',
  styleUrls: ['./process-stages.component.scss']
})
export class ProcessStagesComponent implements OnInit, AfterViewInit {

  // @Input() prTypeID: number = 1;

  jobDetails: any = [];
  jobItems: any = [];
  generation: any = [];
  Items: any = [];
  JobProducts: any = [];
  Reasons: any = [];
  newstage: any = '';
  newstageID: any = 0;
  notes: any = ''
  stagesOfProds: any = [];
  Users: any = [];
  jarvisData: any = [];
  prTypeID: number = 1;
  prjStages: any = [];
  enblAddStages: boolean = false;
  genList: any = [];
  rejList: any = [];
  conList: any = [];
  stageTaskDetail: any= [];
  projectDetails: any = {};
  newStageList: any = [];
  taskDetails: any = [];
  selStageData: any;
  todayDate: Date = new Date();
  currStageID: number = 0;
  
 

  constructor(private modalService: NgbModal, private router: Router, public commonFun: CommonService,
    private apiService: APIService, private dataSer: DataService, private route: ActivatedRoute) {

    this.dataSer.WIPDetails.subscribe((value: any) => {

      this.stagesOfProds = [];
      let Config: any = this.apiService.getCookie("ERP_Cfg");
      let tempReasons = JSON.parse(Config)
      this.Reasons = JSON.parse(tempReasons[0].PrdRejnReasons)
      this.Stages = JSON.parse(tempReasons[0].PrdJobStages)

      this.apiService.getIDB('erp_inv', (tempItems: any) => {
        if (tempItems && tempItems.length > 0) {
          this.Items = tempItems;
        }
      });

      let tempUsers = this.apiService.getCookie("J");
      if (tempUsers) {
        this.Users = JSON.parse(tempUsers)
      }

      let jarvis = this.apiService.getCookie("Jarvis");
      if (jarvis) {
        this.jarvisData = JSON.parse(jarvis);
      };

      if (value) {
        
        this.jobDetails = value.Table1;
        this.jobItems = value.Table2;
        this.JobProducts = value.Table3;
        this.stageTaskDetail = value.Table4 ? value.Table4 : [];
        //this.generation =  this.jobDetails[0].Generation
        if (this.jobDetails) {
          
          this.projectDetails.projectName = this.jobDetails[0].JobNo;
          this.currStageID = this.jobDetails[0]?.StageID ? this.jobDetails[0]?.StageID : 0;

          this.stageList  = [];
          this.prTypeID = this.jobDetails[0].JobTypeID;
          let tempStageList = JSON.parse(this.jobDetails[0].Stages);
          if(tempStageList.length > 0){
            tempStageList.forEach((p: any) => {
              if(!p.TID){
                p.TID = 1
              }
            });
            
            let tempPrdStgList = tempStageList.filter((a: any) => a.TID == 1)
            if(this.prTypeID == 1 && tempPrdStgList.length > 0){

                tempPrdStgList.forEach((item: any) => {
                      let tmpStg = this.Stages.filter((s: any) => s.SID == item.SID);
                        let selectedUsers = String(tmpStg[0].UIDs).split(",");
                        for(let i: number = 0; i < selectedUsers.length; i++){
                          if(selectedUsers[i] == this.jarvisData[0].UserID){
                            this.stageList.push(tmpStg[0])
                          }
                        }
                    }) 
                    
                
              //this.stageList = tempPrdStgList;
              // this.stageList = this.stageList.sort((a: any, b: any) => a.SNm.localeCompare(b.SNm));
              this.stageList.sort((a: any, b: any) => a.Seq - b.Seq);
              let ind = this.stageList.map(function(o: any) { return o.SNm; }).indexOf(this.jobDetails[0].Stage);
            }
            // Stages Check for Projects
            this.setStageList(tempStageList);

            if (this.stageList && this.stageList.length > 0){
              const stage = this.stageList[0];
              if (stage && ('IN' in stage || 'CN' in stage)) {
                this.enblAddStages = true;
              }
              else {
                this.enblAddStages = false;
              }
            }
         
            if (this.enblAddStages) {
              this.setProjectStages(this.stageList);                
            }
          }
          
          
          // this.stageList.splice(ind, 1);

          let tempStage = this.jobDetails[0].History;
          let tempData = JSON.parse(tempStage)
          let temp = tempData.filter((s: any) => s.Typ == 'MVM')
          this.stagesOfProds = temp;
          this.stagesOfProds.forEach((o: any) => {
            let data = this.Stages.filter((a: any) => a.SID == o.FStgID)
            let Newdata = this.Stages.filter((a: any) => a.SID == o.TStgID)
            let TempUSers = this.Users.filter((x: any) => x.UserID == o.By)
            o.OnNew = new Date(o.On).customFormat("#DD#-#MMM#-#YY#")
            o.time = new Date(o.On).customFormat("#hh#:#mm# #AMPM#")
            
            if (data.length > 0) {
              o.FStg = data[0].SNm
            }
            else {
              //o.FStg = 'Packing'
              o.FStg = 'Unstarted'
            }
            if (Newdata.length > 0) {
              o.TStg = Newdata[0].SNm
            } else {
              //o.TStg = 'Packing'
              o.FStg = 'Unstarted'
            }
            if (TempUSers.length > 0) {
              o.By = TempUSers[0].Name
            } else {
              o.By = ''
            }

          });

        }
        if (this.JobProducts) {

          for (let x = 0; x < this.JobProducts.length; x++) {
            let tempfilter = this.Items.filter((u: any) => u.ItemID == this.JobProducts[x].PID)
            if (tempfilter.length > 0) {
              this.JobProducts[x].ItemName = tempfilter[0].ItemName
              this.JobProducts[x].Rsn = ''
              this.JobProducts[x].RjctQty = ''
            }
            else {
              this.JobProducts[x].ItemName = ''
              this.JobProducts[x].Rsn = ''
              this.JobProducts[x].RjctQty = ''
           }
          }
        }
      }
      else {
      //rights check
      if (this.Stages) {
        
        if(this.jarvisData[0].UserID > 0){
          this.stageList = [];
          for(let i: number = 0; i < this.Stages.length; i++){
            if(this.Stages[i].UIDs && this.prTypeID != 1){
            let selectedUsers = String(this.Stages[i].UIDs).split(",");
              for(let j: number = 0; j < selectedUsers.length; j++){
                if(selectedUsers[j] == this.jarvisData[0].UserID){
                  let temPrdStg = this.Stages.filter((a: any) => a.TID == 1)
                  let tmpProjetcStg = this.Stages.filter((a: any) => a.TID == 2)
                  if(this.prTypeID == 1 && temPrdStg.length > 0)
                  {
                    this.stageList.push(temPrdStg);
                  }
                  if(this.prTypeID == 1 && tmpProjetcStg.length > 0)
                  {
                    this.stageList.push(tmpProjetcStg);
                  }
                  
                }
              }
            }     
            else {
              this.stageList.push(this.Stages[i]);
            }
          }
        }
      }
      }
    });

    this.dataSer.updateWIPDetails(this.stageTaskDetail);
  }



  //#region "Declaration"
  @Input() stageData: any;
  @Input() mdlRef: any;
  @ViewChild('mdlStageEntry') mdlStageEntryRef!: TemplateRef<any>;
  @ViewChild('AddStage') addStageRef!: TemplateRef<any>;
  prductData: any = {
    productID: 0,
    productName: 'Blue Led Light'
  };

  //jarvisData: any = [];
  agencyData: any = [];
  stageList: any = [];
  Stages: any = [];

  selectedStages: any = [];

  stageEntry: any = {
    stageID: 0,
    stageName: '',
    stageOrder: 0
  }

  modalReference: any;
  isEdit: boolean = false;
  newStage = {
      stageName: '',
      TDT: new Date(),
      instruction:'' 
  }
  //#endregion

  ngOnInit(): void {

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    // let jarvis = this.apiService.getCookie("Jarvis");
    // if (jarvis) {
    //   this.jarvisData = JSON.parse(jarvis);
    // };

    let tempUsers = this.apiService.getCookie("J");
    if (tempUsers) {
      this.Users = JSON.parse(tempUsers)
    }

    this.dataSer.moveJobModal.subscribe((value) => {
      if(value == 1) {
        let tmpbtn = document.getElementById('moveJobBtn');
        tmpbtn?.click();
        //this.dataSer.updateMoveJobModal(0);
      }
    })

    // this.dataSer.projectData.subscribe((value: any) => {
    //   debugger
    //   if(value.prTypeID != '' && value.prTypeID != undefined){
    //     this.prTypeID = value.prTypeID;
    //   }
    // });

  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          if (this.prTypeID == 2 && this.enblAddStages) {
            this.openStageEntryModal(this.addStageRef, 0);
          } else {
            this.open(this.mdlStageEntryRef);
          }
        }, 100);
      }
    });
  }


  //#region "Function"

  addNewStages() {
    if (this.stageEntry.stageID == 0 || this.stageEntry.stageName == '') {
      alert("Please select a stage.");
      return;
    }
    this.selectedStages.push({
      stageID: this.stageEntry.stageID,
      stageName: this.stageEntry.stageName,
      stageOrder: this.stageEntry.stageOrder
    });

    this.closeModal();
  }

  open(content: any) {
    this.modalReference = this.modalService.open(content, {windowClass: "openStageModal", ariaLabelledBy: 'modal-basic-title' });
    // this.modalReference.componentInstance.prTypeID = this.prTypeID;
  }

  closeModal() {
    this.stageEntry.stageID = 0;
    this.stageEntry.stageName = '';
    this.stageEntry.stageOrder = 0;
    this.newStage.stageName = '';
    this.newStage.TDT = new Date();
    this.newStage.instruction = '';
    this.modalReference.close();
  }


  removeStage(ind: any) {
    this.selectedStages.splice(ind, 1);
  }


  blurStage() {
    let tempStage = this.stageList.filter((x: any) => x.SNm == this.newstage)

    if (tempStage.length > 0) {
      this.newstageID = tempStage[0].SID
    }
    else {
      this.newstageID = 0
      this.newstage = ''
    }
  }


  goBack() {
    // window.history.back();
    this.mdlRef.close('Close');
  }

  //saveStages() - Save Stages in Database
  MoveJob() {
    
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
    if( this.newstage == ''){
      alert("Please select a valid stage.");
      return;
    }

    const jobDetails = this.getPreparedJsons();
    let rejectionList: any = jobDetails?.rejection;
    let generationList: any = jobDetails?.generation;
    let ConsumptionList: any = jobDetails?.consumption;
  
    var tempData = [{
      'JobID': this.jobDetails[0].JobID,
      'NewStageID': this.newstageID,
      'NewStage': this.newstage,
      'Generation': JSON.stringify(generationList),
      'Consumption': JSON.stringify(ConsumptionList),
      'Rejection': JSON.stringify(rejectionList),
      'Notes': this.notes
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'MoveJob',
      moduleID: 7,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successStageEntry.bind(this), this.failureStageResp.bind(this));

  }

  //failureResp - failure handler
  failureStageResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successStageEntry(res: any) {
    
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          alert(reponseData.Table[0].ErrMsg);
          // this.router.navigateByUrl('/Stock');
        }
        else {
          this.modalReference.close();
          var obj: any = {
            FStg: this.jobDetails[0].Stage,
            TStg: this.newstage,
            Notes: this.notes,
            By:  this.jarvisData[0].UserName,
            OnNew : new Date().customFormat("#DD#-#MMM#-#YY#"),
            time : new Date().customFormat("#hh#:#mm# #AMPM#")
          }
          this.stagesOfProds.push(obj)
       
          for (let x = 0; x < this.JobProducts.length; x++) {
            let tempfilter = this.Items.filter((u: any) => u.ItemID == this.JobProducts[x].PID)
            if (tempfilter.length > 0) {
              this.JobProducts[x].ItemName = tempfilter[0].ItemName
              this.JobProducts[x].Rsn = ''
              this.JobProducts[x].RjctQty = ''
            }
            else {
              this.JobProducts[x].ItemName = ''
              this.JobProducts[x].Rsn = ''
              this.JobProducts[x].RjctQty = ''
            }
          }

          this.newstage = '';
          this.newstageID = 0;

          let sendObj = {
            jobNo: this.jobDetails[0].JobID,
            action: 1
          }
          this.dataSer.updateStageEntered(sendObj);
          // this.router.navigateByUrl('/ProductDetail?PID=' + this.prductData.productID);
        }
      }
    }
  }

  openEnterStage(obj:any = {}, event : MouseEvent) {
    event.stopPropagation();
    const jobDetails = this.getPreparedJsons();

    this.modalReference = this.modalService.open(EnterStageComponent, {windowClass: "entStgMdl", ariaLabelledBy: 'modal-basic-title' , backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.jobID = this.jobDetails[0].JobID;
    this.modalReference.componentInstance.jobDetails = jobDetails;
    this.modalReference.componentInstance.stageData = obj;
    // this.modalReference.componentInstance.testStr = "Hello world";

    this.modalReference.result.then((result: any) => {
      if (result.action == 'Done') {
        let stages = result.stages ? JSON.parse(result.stages) : [];
        this.setStageList(stages);
        let sendObj = {
          jobNo: this.jobDetails[0].JobID,
          action: 1
        }
        this.dataSer.updateStageEntered(sendObj);
      }
    });
    
    this.dataSer.updateProductStages(this.stageList);
  }

  setProjectStages(stages: any) {
    this.prjStages = stages;
    let dateOptions: any = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };

    this.prjStages.forEach((stage: any) => {
      stage.startDT = stage.SDT ? (new Date(stage.SDT).customFormat("#DD#-#MMM#-#YY#")) : '-'; 
      stage.startDTFull = stage.SDT ? (new Date(stage.SDT).customFormat("#DD#-#MMM#-#YY#")) + " @ " + (new Date(stage.SDT).customFormat("#hh#:#mm# #AMPM#")) : '-'; 
      stage.targetDT = stage.TDT ? (new Date(stage.TDT).customFormat("#DD#-#MMM#-#YY#")) : '-'; // + " @ " + (new Date(stage.TDT).customFormat("#hh#:#mm# #AMPM#")) : '-'; 
      stage.endDT = stage.EDT ? (new Date(stage.EDT).customFormat("#DD#-#MMM#-#YY#")) : '-'; 
      stage.endDTFull = stage.EDT ? (new Date(stage.EDT).customFormat("#DD#-#MMM#-#YY#")) + " @ " + (new Date(stage.EDT).customFormat("#hh#:#mm# #AMPM#")) : '-'; 
      
      let startByUID = stage.SUID ? stage.SUID : 0;
      let tempUsers = this.Users.filter((x: any) => x.UserID == startByUID);
      stage.by = tempUsers.length > 0 ? tempUsers[0].Name : '-';
      stage.tasksCnt = this.stageTaskDetail.filter((x:any)=>x.ProjectStageID == stage.SID).length;
    });
    // this.prjStages.sort((a:any,b:any) => a.SDT.localeCompare(b.SDT));

    this.prjStages.sort((a: any, b: any) => a.Seq - b.Seq);
  }

  setStageList(stages: any) {
    this.stageList = [];
    if (this.prTypeID != 1) {
      stages.forEach((stage: any) => {
        let stageUserIds = String(stage.UIDs).split(",").length > 0 ? String(stage.UIDs).split(",") : [];
        let currUser = stageUserIds.filter((x: any) => x == this.jarvisData[0].UserID)
        if (currUser.length > 0) {
          this.stageList.push(stage);
        }
      });
    } else {
      let currStgID = this.currStageID;
      this.stageList = $.grep(stages, function(o: any){ return o.SID != currStgID });
    }
    // this.stageList = this.stageList.sort((a: any, b: any) => a.SNm.localeCompare(b.SNm)); 
    this.stageList.sort((a: any, b: any) => a.Seq - b.Seq);
    this.newStageList = JSON.parse(JSON.stringify(this.stageList));
    this.setProjectStages(this.stageList);
  }

  getPreparedJsons() {
    let generationList: any = [];
    let ConsumptionList: any = [];
    let rejectionList: any = [];
    
    for (let i = 0; i < this.JobProducts.length; i++) {
      let obj = {
        ItemID: this.JobProducts[i].PID,
        PlanQty: this.JobProducts[i].PlanQty,
        DoneQty: this.JobProducts[i].GenQty,
        XnIDs: '',
        Description: this.JobProducts[i].D ? this.JobProducts[i].D : ''
      }
      generationList.push(obj);

      if (true) {

        let tempReason = this.Reasons.filter((x: any) => x.Rsn == this.JobProducts[i].Rsn)

        if(this.JobProducts[i].RjctQty > 0 && tempReason.length == 0) {
          alert("Please select a valid reason.");
          return;
        }

        if(tempReason.length > 0){
          var objRjcn = {
            RejEntryID: i + 1,
            RID: tempReason[0].RID,
            ProductID: this.JobProducts[i].PID,
            RejQty: this.JobProducts[i].RjctQty,
            RejNotes: this.JobProducts[i].Rsn
          }
        }
        else{
          objRjcn = {
            RejEntryID: i + 1,
            RID:0,
            ProductID: this.JobProducts[i].PID,
            RejQty: this.JobProducts[i].RjctQty,
            RejNotes: this.JobProducts[i].Rsn
          }
        }
        rejectionList.push(objRjcn)
      }
    }
    
    for (let i = 0; i < this.jobItems.length; i++) {
      let obj = {
        ItemID: this.jobItems[i].MID,
        PlanQty: this.jobItems[i].PlanQty,
        DoneQty: this.jobItems[i].UsedQty,
        XnIDs: '',
        Description: this.jobItems[i].D ? this.jobItems[i].D : ''
      }
      ConsumptionList.push(obj);
    }

    return {
      generation: generationList,
      rejection: rejectionList,
      consumption: ConsumptionList
    };
  }

  openTaskListModal(proj: any){
    const jobDetails = this.getPreparedJsons();
    this.modalReference = this.modalService.open(StageTasksListComponent, {windowClass:'stageTaskStyles',ariaLabelledBy: 'hello-world', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.jobDetails = jobDetails;
    
    this.modalReference.componentInstance.proj = proj;

    this.modalReference.result.then((result: any) => {
      if (result.action == 'Done') {
        let stages = result.stages ? JSON.parse(result.stages) : [];
        this.setStageList(stages);
      }
    });
  }
  
  openStageEntryModal(content: any, id: number) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'addStageMdl', backdrop: 'static', keyboard: false });
  }
   // addStage() - add new unit
   addStage(stage: any, obj: any){
    this.newStage = stage;

    if(this.newStage.stageName == ''){
      alert("Please enter stage name.")
      return;
    }
    let similarStages = this.newStageList.filter((stage: any)=> stage.SNm.toUpperCase() == this.newStage.stageName.toUpperCase());
    if(similarStages.length > 0){
      alert("This stage already exists.")
      this.newStage.stageName = ""
      return;
    }

    let projUseIDs = this.jobDetails[0].UserIDs ? this.jobDetails[0].UserIDs : '';
    
    this.newStageList.push({
      SID: Math.max(0, ...this.newStageList.map((obj: any) => Number(obj.SID? obj.SID : "0"))) + 1,
      SNm: this.newStage.stageName,
      Seq: Math.max(0, ...this.newStageList.map((obj: any) => Number(obj.Seq? obj.Seq : "0"))) + 1,
      UIDs: projUseIDs,
      TID: this.prTypeID,
      IN: this.newStage.instruction,
      CN: '',
      TDT: new Date(this.newStage.TDT).customFormat("#DD#-#MMM#-#YY#")
    });

    this.newStage.stageName = "";
    this.newStage.instruction = "";
    this.newStage.TDT = new Date();
    this.save();
    this.modalReference.close();
  }
  //save() - save stage
  save(){
    let tempStages = [];
    const jobDetails = this.getPreparedJsons();
    let generationList: any = jobDetails?.generation;
    let ConsumptionList: any = jobDetails?.consumption;
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
    tempStages = this.newStageList;
      var tempData = [
        {
          'JobID': this.jobDetails[0].JobID,
          'TargetDT': new Date(),
          'Stages': JSON.stringify(tempStages),
          'Generation': JSON.stringify(generationList),
          'Consumption': JSON.stringify(ConsumptionList),
          'ChangeType': 'PROJSTGADD',
          'prdTypeID': 2
        }
      ];
  
      let myParams = [
        {
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: MyLastSyncDT,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'setDetail',
          moduleID: 7,
          data: JSON.stringify(tempData),
        },
      ];
      this.apiService.sendChange(myParams, this.successNewStageEntry.bind(this), this.failureNewStageResp.bind(this));
    }

    successNewStageEntry (res: any) {
      if (res.error) {
      }
      else {
        if (res) {
          var data = JSON.parse(res.updatePackage);
          this.stageList = JSON.parse(data.Table[0].Stages);
          this.setStageList(this.stageList);
        }   
        let sendObj = {
          jobNo: this.jobDetails[0].JobID,
          action: 1
        }
        this.dataSer.updateStageEntered(sendObj);
        this.modalReference.close();
      }
    }
    failureNewStageResp (res: any) {
      if (res.error) {
      }
      else {
        alert(res.message);
      }
    }

    openCNEntryModal(content: any, stageDetail: any, event : MouseEvent) {
      event.stopPropagation();
      this.taskDetails = this.stageTaskDetail;
      this.selStageData = stageDetail;
      this.taskDetails = this.taskDetails.filter((x:any)=>x.ProjectStageID == stageDetail.SID);
     
      let openTasks = this.taskDetails.filter((a: any) => a.StatusID != 3);
      if (openTasks.length > 0) {
        this.apiService.successAlert('This stage cannot be marked as done as there are open tasks linked with it.');
        return;
      }
  
      this.modalReference = this.modalService.open(content, {windowClass: "openStageModal", ariaLabelledBy: 'modal-basic-title' });
    }
    closeCNEntryModal() {
      this.modalReference.close();
    }

    // markStageDone() - Mark job stage as done.
    markStageDone () {
      let openTasks = this.taskDetails.filter((a: any) => a.StatusID != 3);
      if (openTasks.length > 0) {
        this.apiService.successAlert('This stage cannot be marked as done as there are open tasks linked with it.');
        return;
      }
      const jobDetails = this.getPreparedJsons();
      let rejectionList: any = jobDetails?.rejection;
      let generationList: any = jobDetails?.generation;
      let ConsumptionList: any = jobDetails?.consumption;

      let myLastSyncDT = localStorage.getItem("MyLastSyncDT");
    
      var tempData = [{
        'JobID': this.jobDetails[0].JobID,
        'NewStageID': this.selStageData.SID,
        'NewStage': this.selStageData.SNm,
        'targetDT': '',
        'Notes': this.selStageData.CN ? this.selStageData.CN : '',
        'Generation': JSON.stringify(generationList),
        'Consumption': JSON.stringify(ConsumptionList),
        'Rejection': JSON.stringify(rejectionList),
        'changeType': 'PRJEND'
      }];

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: myLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'MoveJob',
        moduleID: 7,
        data: JSON.stringify(tempData)
      }];

      this.apiService.sendChange(myParams, this.successDoneStage.bind(this), this.failureDoneStage.bind(this));
    }
    successDoneStage(res: any) {
      if (res.error) {
      }
      else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          // this.mdlRef.close();
          if (reponseData.Table[0].ErrCode != -1) {
            alert(reponseData.Table[0].ErrMsg);
          }
          else {
            let data = reponseData.Table[0];
            let stages = JSON.parse(data.Stages);
            this.setStageList(stages);
            let sendObj = {
              jobNo: this.jobDetails[0].JobID,
              action: 1
            }
            this.dataSer.updateStageEntered(sendObj);
            this.closeCNEntryModal();
          }
        }
      }
    }

    failureDoneStage(res: any) {
      if (res.error) {
      }
      else {
        alert(res.message);
      }
    }
  //#endregion
}



declare global {
  interface Date {
    customFormat(formatString : any): string;
  }
}

// String Prototye
Date.prototype.customFormat = function(formatString : any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}

